import React from "react";
import { Box, Typography } from "@mui/material";

import { formatCurrency } from "../../utils/utils";

import styles from "../../modules/past-orders/components/CartItemsWithModifiers.module.scss";

export const DojoCartItemsWithModifiers = ({ cartList, checkoutFontColor }) => {
  return (
    <Box>
      <Box className={styles.cartItemListView} mt={2} mb={1}>
        {cartList?.map((item, i) => {
          return (
            <Box sx={{ mb: 1 }}>
              <Box key={i} className={styles.cartItemMainView}>
                <Box dir={"ltr"} display={"flex"} flexDirection={"row"}>
                  <Box className={styles.itemQtyView}>
                    <Typography className={styles.itemQtyText}>
                      {item.count ?? item?.quantity}x
                    </Typography>
                  </Box>
                  <Box className={styles.itemNameView} pr={2}>
                    <Typography
                      className={styles.itemNameText}
                      sx={{
                        color: `${checkoutFontColor ?? "#000"} !important`,
                      }}
                    >
                      {item.name ?? item?.menuItemName}
                    </Typography>
                  </Box>
                </Box>
                <Box className={styles.itemPriceView}>
                  <Typography
                    className={styles.itemPriceText}
                    sx={{ color: `${checkoutFontColor ?? "#000"} !important` }}
                  >
                    {formatCurrency(
                      item?.price?.value *
                        (item?.count ? item?.count : item?.quantity)
                    )}
                  </Typography>
                </Box>
              </Box>
              {item?.modifiers?.length > 0 &&
                item?.modifiers?.map((modifier, modIndex) => (
                  <Box key={modIndex} className={styles.modifierItemView}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box className={styles.itemQtyView}>
                        <Typography
                          className={styles.itemQtyText}
                          sx={{
                            fontSize: "12px !important",
                            fontFamily: "Inter !important",
                            fontWeight: 300,
                          }}
                        >
                          {item.quantity}x
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          flex: 1,
                        }}
                        pr={2}
                      >
                        <Typography
                          className={styles.modifierNameText}
                          sx={{
                            color: `${checkoutFontColor ?? "#000"} !important`,
                            fontSize: "12px !important",
                            fontFamily: "Inter !important",
                            fontWeight: 300,
                          }}
                        >
                          {modifier?.menuItem?.name}
                        </Typography>
                      </Box>
                      <Box className={styles.modifierPriceView}>
                        <Typography
                          className={styles.modifierPriceText}
                          sx={{
                            color: `${checkoutFontColor ?? "#000"} !important`,
                            fontSize: "12px !important",
                            fontFamily: "Inter !important",
                            fontWeight: 300,
                          }}
                        >
                          {modifier?.price?.value === 0
                            ? "FREE"
                            : formatCurrency(
                                modifier?.price?.value * item?.quantity
                              )}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default DojoCartItemsWithModifiers;
